<template>
  <div class="p-5 container">
    <div class="p-5" style="background: #ffffff;display: flex;flex-direction: column;align-items: center;">
      <p class="text-section" style="font-weight: 700; color: #323563;">
        การสอบของฉัน
      </p>
      <div v-if="listExamCenter && listExamCenter.length > 0" class="p-5">
        <div class="container my-10 row">
          <div
            class="col-12 col-md-6 col-lg-4 mb-5"
            v-for="(item, index) in listExamCenter"
            :key="index"
          >
            <div
              class="box-item p-0 h-100"
              :disabled="item.examRoomProfile.open == false"
              style="border-radius: 10px;border: 1px solid #dbdbdb;background: #fff;padding: 10px;display: flex;flex-direction: column;"
            >
              <div class="p-0">
                <img
                  :src="imageUrl + item.examRoomProfile.examProfile.thumbnailsPath"
                  @error="setAltImg"
                  alt=""
                  class="w-100"
                  style="border-radius: 10px;height: auto;object-fit: contain;"
                />
              </div>
              <div class="p-5">
                <div
                  class="mb-5 limit-text text-title"
                  style="font-weight: 700; font-size: 20px; color: #323563"
                >
                  {{ item.examRoomProfile.examProfile.title }}
                  {{ item.examRoomProfile.syllabusProfile.name }}
                </div>
                <p class="text-category" style="font-weight: 700; color: #da595a">
                  รหัส : {{ item.examRoomProfile.examRoomCode }}
                </p>
                <p class="text-category" style="font-weight: 700; color: #333333">
                  รอบที่สอบ :
                  <span class="text-category" style="font-weight: 700; color: #da595a">
                    {{ formatDateTime(item.examRoomProfile.startDate) }}
                    -
                    {{ formatDateTime(item.examRoomProfile.endDate) }}</span
                  >
                </p>
                <p class="text-category" style="font-weight: 700; color: #333333">
                  ชื่อศูนย์สอบ :
                  <span class="text-category" style="font-weight: 700; color: #da595a">
                    {{ item.examRoomProfile.examCenterProfile.name }}</span
                  >
                </p>
                <p class="text-category" style="color: #323563">
                  หมวดหมู่ :
                  {{
                    item.examRoomProfile && item.examRoomProfile.examProfile && item.examRoomProfile.examProfile.categoryProfile && item.examRoomProfile.examProfile.categoryProfile.length > 0
                      ? item.examRoomProfile.examProfile.categoryProfile[0] && item.examRoomProfile.examProfile.categoryProfile[0][0] && item.examRoomProfile.examProfile.categoryProfile[0][0].data
                      : "-"
                  }}
                </p>
                <p class="text-category" style="color: #323563">
                  จำนวนข้อสอบ :
                  {{ item.examRoomProfile.examProfile.totalQuestion }} ข้อ
                </p>
                <p class="text-category" style="color: #323563">
                  คะแนนเต็ม :
                  {{ item.examRoomProfile.examProfile.totalScore }} คะแนน
                </p>
                <button
                  type="button"
                  class="btn w-100"
                  :disabled="item.examRoomProfile.open == false"
                  style="border-radius: 100px;background: var(--323563, #323563);color: #FFF;"
                  @click="
                    registerExamRoom(
                      item.examRoomId,
                      item.examRoomProfile.flgPwd,
                      item.examRoomProfile.photo,
                      item.examRoomProfile.examRoomCode,
                      item.examRoomProfile.startDate,
                    )
                  "
                >
                  เข้าสู่การสอบ
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <img src="media/image-app/pana.svg" alt="" class="w-100" />
        <p class="text-center">ปัจจุบันคุณยังไม่มีการสอบ</p>
      </div>
    </div>

    <!-- modal ยืนยันรหัสห้องสอบ -->
    <div class="modal fade" id="kt_modal_password" ref="modalPassword">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <h3 class="modal-title" style="text-align: center">
              กรุณากรอกรหัสห้องสอบ
            </h3>
            <p class="text-center">รหัสห้องสอบได้จากเจ้าหน้าที่ดูแลศูนย์สอบ</p>
          </div>
          <div class="modal-body text-center">
            <div style="position: relative;">
              <input
                class="form-control form-control-lg"
                :type="passwordFieldType"
                v-model="roomPwd"
              />
              <button
                style="position: absolute;top: 0;right: 5px;"
                type="button"
                class="btn"
                @click="switchVisibility"
              >
                <i class="fa fa-eye"></i>
              </button>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              data-bs-dismiss="modal"
              style="border-radius: 21px"
            >
              ยกเลิก
            </button>
            <button
              type="button"
              class="btn"
              style="color: var(--ffffff, #fff);border-radius: 29px;background: var(--323563, #323563);"
              @click="submitPassword"
            >
              ตกลง
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { Modal } from "bootstrap";
import { hideModal } from "@/core/helpers/dom";

const roomcode = ref();
const roomPwd = ref();
const flgPhoto = ref();
const modalPassword = ref<null | HTMLElement>(null);

export default defineComponent({
  name: "my-exam",
  data() {
    return {
      imageUrl: process.env.VUE_APP_IMG_URL,
      passwordFieldType: "password",
      listExamCenter: null as any,
    };
  },
  setup() {
    const router = useRouter();

    const getExamRoomRegister = () => {
      return axios.get(
        process.env.VUE_APP_API_URL +
          "/getExamRoomRegister" +
          "?sizeContents=9&page=0&status=0,1&isDetail=true&userId=" +
          localStorage.getItem("u_id") +
          "&startDateEnter=",
        {
          headers: {
            token: localStorage.getItem("id_token"),
          },
        },
      );
    };

    const enterRoom = async () => {
      const formData = new FormData();
      formData.append("examRoomCode", roomcode!.value + "");
      await axios
        .post(process.env.VUE_APP_API_URL + "/enterExamRoomRegister", formData, {
          headers: {
            token: localStorage.getItem("id_token"),
          },
        })
        .then((response) => {
          if (response.data.code == 200) {
            router.push({
              name: "exam-detail-noheader",
              params: { id: response.data.data.examRoomId },
            });
          } else {
            Swal.fire({
              text: response.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "ลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            text: error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    };

    return {
      router,
      getExamRoomRegister,
      enterRoom,
      roomcode,
      roomPwd,
      flgPhoto,
      modalPassword,
    };
  },
  async mounted() {
    const modalPasswordEl = document.getElementById("kt_modal_password");
    if (modalPasswordEl) {
      new Modal(modalPasswordEl);
    }
    try {
      const { data } = await this.getExamRoomRegister();
      const content = data?.data?.content || [];
      const list: any = [];
      for (const loopData of content) {
        if (loopData.startTestDate != null) {
          if (
            new Date(loopData.startTestDate).getTime() >
            new Date().setHours(0, 0, 0)
          ) {
            list.push(loopData);
          }
        } else if (loopData.examRoomProfile?.endDate) {
          if (
            new Date(loopData.examRoomProfile.endDate).getTime() >
            new Date().setHours(0, 0, 0)
          ) {
            list.push(loopData);
          }
        }
      }
      this.listExamCenter = list;
    } catch (error) {
      this.listExamCenter = [];
    }
  },
  methods: {
    setAltImg(event) {
      event.target.src = "media/image-app/no-image.svg";
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    formatDateTime(date) {
      const event = new Date(date);
      return (
        event.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }) + " น."
      );
    },
    async registerExamRoom(id, flgPwd, photo, examRoomCode, startDate) {
      console.log("registerExamRoom");
      
      if (startDate && new Date().getTime() >= new Date(startDate).getTime()) {
        roomcode.value = examRoomCode;
        flgPhoto.value = photo;
        if (flgPwd && photo) {
          const myModal = Modal.getInstance(this.$refs.modalPassword as HTMLElement);
          myModal?.show();
        } else if (flgPwd) {
          const myModal = Modal.getInstance(this.$refs.modalPassword as HTMLElement);
          myModal?.show();
        } else if (photo) {
          this.$router.push({
            name: "verify",
            params: { examRoomCode: examRoomCode },
          });
        } else {
          const formData = new FormData();
          formData.append("examRoomCode", examRoomCode + "");
          await axios
            .post(
              process.env.VUE_APP_API_URL + "/enterExamRoomRegister",
              formData,
              {
                headers: {
                  token: localStorage.getItem("id_token"),
                },
              },
            )
            .then((response) => {
              if (response.data.code == 200) {
                console.log("response.data.data.examRoomId", response.data.data);
                this.$router.push({
                  name: "exam-detail-noheader",
                  params: { id: id },
                });
              } else {
                Swal.fire({
                  text: response.data.message,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "ลองใหม่ภายหลัง!",
                  customClass: {
                    confirmButton: "btn fw-semobold btn-light-danger",
                  },
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                text: error.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "ลองใหม่ภายหลัง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-danger",
                },
              });
            });
        }
      } else {
        Swal.fire({
          text: "ยังไม่ถึงเวลาเข้าสอบ",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "ลองใหม่ภายหลัง!",
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
      }
    },
    async submitPassword() {
      hideModal(this.$refs.modalPassword as HTMLElement);
      const formData = new FormData();
      formData.append("examRoomCode", roomcode!.value + "");
      formData.append("examRoomPwd", roomPwd!.value + "");
      await axios
        .post(process.env.VUE_APP_API_URL + "/checkExamRoomRegister", formData, {
          headers: {
            token: localStorage.getItem("id_token"),
          },
        })
        .then(async (response) => {
          if (response.data.code == 200) {
            if (flgPhoto.value == true) {
              this.$router.push({
                name: "verify",
                params: { examRoomCode: roomcode.value },
              });
            } else {
              await this.enterRoom();
            }
          } else {
            Swal.fire({
              text: response.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "ลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            text: error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    },
  },
});
</script>
